__turbopack_context__.v({
  "cardName": "comboResult-module-scss-module__Z6bhxG__cardName",
  "comboResultSection": "comboResult-module-scss-module__Z6bhxG__comboResultSection",
  "prerequisites": "comboResult-module-scss-module__Z6bhxG__prerequisites",
});
